export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|([1-5][0-9])|(6[0-3]))[0-9]{3}$/i));
    }
}
